import React from 'react';
import { Link } from 'react-router-dom';
import { Book, Eye, Star } from 'lucide-react';
import './NovelCard.css';

const NovelCard = ({ novel, variant = 'default' }) => {
  if (!novel) return null;

  const formatViews = (views) => {
    if (!views) return '0';
    if (views >= 1000000) return (views / 1000000).toFixed(1) + 'M';
    if (views >= 1000) return (views / 1000).toFixed(1) + 'K';
    return views.toString();
  };

  const getStatusLabel = (status) => {
    const labels = {
      ongoing: 'Ongoing',
      completed: 'Completed',
      hiatus: 'Hiatus',
      dropped: 'Dropped'
    };
    return labels[status] || status;
  };

  if (variant === 'horizontal') {
    return (
      <Link to={`/novel/${novel.slug}`} className="novel-card horizontal">
        <div className="card-cover">
          {novel.cover ? (
            <img src={novel.cover} alt={novel.title} loading="lazy" />
          ) : (
            <div className="cover-placeholder">
              <Book size={24} />
            </div>
          )}
        </div>
        
        <div className="card-content">
          <h3>{novel.title}</h3>
          <p className="card-author">{novel.author}</p>
          <div className="card-stats">
            <span><Book size={12} /> {novel.chapterCount} ch</span>
            <span><Eye size={12} /> {formatViews(novel.stats?.views)}</span>
            <span><Star size={12} fill="currentColor" /> {novel.rating?.average?.toFixed(1) || '0'}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/novel/${novel.slug}`} className={`novel-card ${variant}`}>
      <div className="card-cover">
        {novel.cover ? (
          <img src={novel.cover} alt={novel.title} loading="lazy" />
        ) : (
          <div className="cover-placeholder">
            <Book size={32} />
          </div>
        )}
        
        {novel.isHot && <span className="hot-badge">🔥 HOT</span>}
        
        {novel.status && (
          <span className={`status-badge ${novel.status}`}>
            {getStatusLabel(novel.status)}
          </span>
        )}
      </div>
      
      {/* Always visible title */}
      <div className="card-title">
        <h3>{novel.title}</h3>
      </div>
      
      {/* Hover content */}
      <div className="card-content">
        <h3>{novel.title}</h3>
        <p className="card-author">by {novel.author}</p>
        <div className="card-stats">
          <span><Book size={12} /> {novel.chapterCount}</span>
          <span><Eye size={12} /> {formatViews(novel.stats?.views)}</span>
          <span className="rating-stars">
            <Star size={12} fill="currentColor" /> {novel.rating?.average?.toFixed(1) || '0'}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default NovelCard;
